import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {AddOrUpdateAttributeTypeOptions} from "./options/add-or-update-attribute-type.options";
import {MatDialogRef} from "@angular/material/dialog";
import {DataResponse} from "../../../../network/service/data.response";
import {SnackBarUtil} from "../../../../util/snack.bar.util";

@Component({
  selector: 'app-add-or-update-attribute-type',
  standalone: false,
  templateUrl: './add-or-update-attribute-type.component.html',
  styleUrls: ['./add-or-update-attribute-type.component.scss']
})
export class AddOrUpdateAttributeTypeComponent extends BaseComponent implements OnInit {
  addOrUpdateAttributeTypeOptions = new AddOrUpdateAttributeTypeOptions();
  title?: string;
  type?: string;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<AddOrUpdateAttributeTypeComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.title = this.addOrUpdateAttributeTypeOptions.attributeType.Title;
    this.type = this.addOrUpdateAttributeTypeOptions.attributeType.Type;
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  onSubmitClicked() {
    (this.addOrUpdateAttributeTypeOptions.attributeType.AttributeTypeId !== undefined ? this.serviceApi.updateAttributeType(this.addOrUpdateAttributeTypeOptions.attributeType.AttributeTypeId, {
      Title: this.title,
      Type: this.type
    }) : this.serviceApi.createAttributeType({
      Title: this.title,
      Type: this.type
    })).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        this.addOrUpdateAttributeTypeOptions.onInsertOrUpdateFinished();
        this.noAction();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }
}
